import { createFileRoute } from '@tanstack/react-router'
import { PurchasesListPage } from '../../../features/purchasing/purchases-list-page'
import { purchaseSearchSchema } from '../../../features/purchasing/search'

export const Route = createFileRoute('/_app/purchases/')({
  validateSearch: purchaseSearchSchema,
  component: PurchasesListPage,
})
